import React from "react";
import QueueTable from "./QueueTable";

function ManageQueue() {
    return <QueueTable />;
}

export default React.memo(ManageQueue);
